import { AppIcon } from '@/components/ui/app-icon';
import { Checkbox as CheckboxPrimitive } from 'radix-ui';
import * as React from 'react';

import { cn } from '@/lib/utils';
import { iconCheck, iconMinus } from '@/lib/icons';

function Checkbox({
  className,
  checked,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      className={cn(
        'peer size-4 shrink-0 rounded-[4px] border border-input outline-hidden transition-shadow focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground dark:bg-input/30 dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-primary',
        className
      )}
      checked={checked}
      {...props}
    >
      {/*
        Indicator must FILL the 16×16 Root for ``items-center justify-center``
        to actually center the glyph — was ``grid place-content-center`` on
        a content-sized span, which only centered the glyph within its own
        bounding box (i.e. didn't center it at all) and left the check
        sitting in the top-left corner of the box. ``h-full w-full`` makes
        the Indicator co-extensive with the Root so flex centering bites.
        Icon dropped from 14→10px because the check glyph has almost no
        internal padding (unlike Lucide's Check), so 14px in a
        16px box left no visual breathing room and exaggerated any
        sub-pixel offset.
        The tick is drawn in the text colour (``mono``) in both icon styles:
        Candy's green tick sank into the blue checked fill.
      */}
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        className='flex h-full w-full items-center justify-center text-current transition-none'
      >
        <AppIcon
          icon={checked === 'indeterminate' ? iconMinus : iconCheck}
          mono
          style={{ fontSize: 10 }}
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
